import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { TabView, TabPanel } from "primereact/tabview";
import { getInvoicesDocRef } from "../../../../services/finance/invoice";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SearchInvoiceDocRef({ onSelectDocRef }) {
  const { reload } = useGlobalData();
  const [salesOrders, setSalesOrders] = useState([]);
  const [deliveries, setDeliveries] = useState([]);
  useEffect(() => {
    getInvoiceDocRefData();
  }, [reload]);
  return (
    <TabView className="tabview" scrollable>
      <TabPanel header="Sales Orders" rightIcon="fas fa-tags">
        <CustomDataTableSearch
          data={salesOrders}
          onRefreshData={() => {
            getInvoiceDocRefData();
          }}
          onSelectedData={(rowData, originalEvent) => {
            onSelectDocRef("1", rowData);
          }}
          columns={[
            {
              field: "select",
              body: (rowData) => (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-label-success btn-sm btn-pill btn-bold"
                    onClick={() => onSelectDocRef("1", rowData)}
                  >
                    Select <i className="fas fa-angle-double-right"></i>
                  </button>
                </React.Fragment>
              ),
            },
            {
              header: "Sales Order ID",
              field: "salesOrderCode",
              body: null,
              sortable: true,
            },
            {
              header: "Customer Name",
              field: "customer.customerName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.customer.customerName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "Order Date",
              field: "orderDate",
              body: (rowData) => formatDate(rowData.orderDate),
              sortable: true,
            },
            {
              header: "Goods Issue Status",
              field: "giStatusDesc",
              body: (rowData) => {
                if (rowData.giStatus === 1) {
                  return <Badge variant="danger">{rowData.giStatusDesc}</Badge>;
                } else if (rowData.giStatus === 2) {
                  return (
                    <Badge variant="warning">{rowData.giStatusDesc}</Badge>
                  );
                } else if (rowData.giStatus === 3) {
                  return (
                    <Badge variant="success">{rowData.giStatusDesc}</Badge>
                  );
                } else {
                  return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
                }
              },
              sortable: true,
            },
            {
              header: "Invoice Status",
              field: "invoiceStatusDesc",
              body: (rowData) => {
                if (rowData.invoiceStatus === 1) {
                  return (
                    <Badge variant="danger">{rowData.invoiceStatusDesc}</Badge>
                  );
                } else if (rowData.invoiceStatus === 2) {
                  return (
                    <Badge variant="warning">{rowData.invoiceStatusDesc}</Badge>
                  );
                } else if (rowData.invoiceStatus === 3) {
                  return (
                    <Badge variant="success">{rowData.invoiceStatusDesc}</Badge>
                  );
                } else {
                  return (
                    <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>
                  );
                }
              },
              sortable: true,
            },
            {
              header: "Currency",
              field: "currency.currencyCode",
              body: null,
              sortable: true,
              filter: true,
              hidden: true,
            },
            {
              header: "Grand Total",
              field: "grandTotal",
              body: (rowData) => (
                <NumberFormat
                  value={rowData.grandTotal}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalScale={2}
                  renderText={(value) => (
                    <div className="float-right">
                      {rowData.currency.currencyCode} {value}
                    </div>
                  )}
                />
              ),
              sortable: true,
            },
          ]}
        />
      </TabPanel>
      <TabPanel header="Deliveries" rightIcon="fas fa-truck">
        <CustomDataTableSearch
          data={deliveries}
          onRefreshData={() => {
            getInvoiceDocRefData();
          }}
          onSelectedData={(rowData, originalEvent) => {
            onSelectDocRef("2", rowData);
          }}
          columns={[
            {
              field: "select",
              body: (rowData) => (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-label-success btn-sm btn-pill btn-bold"
                    onClick={() => onSelectDocRef("2", rowData)}
                  >
                    Select <i className="fas fa-angle-double-right"></i>
                  </button>
                </React.Fragment>
              ),
            },
            {
              header: "Delivery ID",
              field: "ID",
              body: null,
              sortable: true,
            },
            {
              header: "Customer Name",
              field: "customer.customerName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.customer.customerName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "Delivery Date",
              field: "deliveryDate",
              body: (rowData) => formatDate(rowData.deliveryDate),
              sortable: true,
            },
            {
              header: "Currency",
              field: "currency.currencyCode",
              body: null,
              sortable: true,
              filter: true,
              hidden: true,
            },
            {
              header: "Delivery Cost",
              field: "deliveryCost",
              body: (rowData) => (
                <NumberFormat
                  value={rowData.deliveryCost}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalScale={2}
                  renderText={(value) => (
                    <div className="float-right">
                      {rowData.currency.currencyCode} {value}
                    </div>
                  )}
                />
              ),
            },
          ]}
        />
      </TabPanel>
    </TabView>
  );
  async function getInvoiceDocRefData() {
    const response = await getInvoicesDocRef();
    const { data } = response.data;
    setSalesOrders(data.salesOrders);
    setDeliveries(data.deliveries);
  }
}

export default SearchInvoiceDocRef;
